module.exports = __webpack_public_path__ + "img/open-in-new.f73ae594.svg";